export const integer = '[0-9.]+';
export const boolean = '0|1';
export const float = '[+-]?[0-9.]+';
export const text = '.*';
export const textareaJson = '.*\\{.*\\:\\{.*\\:.*\\}\\}';
export const array = '\\[[0-9a-zA-Z ,/._%+-\\[\\]]*\\]';
export const unix_timestamp = '([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]'; //source: https://unix.stackexchange.com/questions/523053/regex-for-a-timestamp-hhmmss
